import React, { Component } from 'react';

import Spinner from 'components/Spinner';
import UpdateStatusModalForm from './UpdateStatusModalForm';
import BaseModal from '../BaseModal';

import styles from './styles.module.scss';

class UpdateStatusModal extends Component {
  state = {
    loading: false,
  };

  handleUpdateStatus = () => {
    const { updateSubStatus, sub } = this.props;

    this.setState({ loading: true });
    return updateSubStatus(sub.id).finally(() => {
      this.setState({ loading: false });
    });
  };

  render() {
    const { response, isOpen, closeModal } = this.props;
    const { loading } = this.state;

    return (
      <BaseModal
        isOpen={isOpen}
        title="Update Status"
        onClose={closeModal}
        className={styles.modal}
        confirmBtnText=""
        cancelBtnText=""
      >
        <UpdateStatusModalForm
          onSubmit={this.handleUpdateStatus}
          response={response}
        />
        <Spinner showLoader={loading} />
      </BaseModal>
    );
  }
}

export default UpdateStatusModal;
